export default __webpack_public_path__ + "static/media/blurBG.c2c54966.png";